export const API_URL_SERVICE_QUALIFICATION_ADDRESS_SEARCH = `/shop/api/telia-play/address-search`;
export const API_URL_VAID_FROM_ADDRESS = `/shop/api/telia-play/vaid-from-address`;
export const API_URL_MOCK_ADDRESS = "/shop/api/telia-play/mock-address";
export const API_URL_SELECT_PACKAGE = "/shop/api/telia-play/select-package";
export const API_URL_SAVE_CONTACT_INFO = "/shop/api/telia-play/save-contact-info";
export const API_URL_SUBMIT_ORDER = "/shop/api/telia-play/submit";
